import { render } from "./작성글_승인완료_작성페이지.vue?vue&type=template&id=8d913b44"
import script from "./작성글_승인완료_작성페이지.vue?vue&type=script&lang=js"
export * from "./작성글_승인완료_작성페이지.vue?vue&type=script&lang=js"

import "./작성글_승인완료_작성페이지.vue?vue&type=style&index=0&id=8d913b44&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__